import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles((theme) => ({
    cancel: {
        '& button': {
            fontWeight: theme.font.weight.light,
            width: 90,
            fontSize: theme.font.size.mediumSmall,
            height: 40,
            '&:hover': {
                background: 'transparent',
            },
        },
    },
    viewMore: {
        '& button': {
            color: '#276700',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            textDecoration: 'underline',
            cursor: 'pointer',
            marginRight: 38,
        },
    },
    modalContainer: {
        height: '100vh',
    },
}));
//# sourceMappingURL=styles.js.map